import { render, staticRenderFns } from "./AUCPrices.vue?vue&type=template&id=b3800162"
import script from "./AUCPrices.vue?vue&type=script&lang=js"
export * from "./AUCPrices.vue?vue&type=script&lang=js"
import style0 from "./AUCPrices.vue?vue&type=style&index=0&id=b3800162&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports